import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class SectionStyling extends Vue {
	@Prop({
		type: String,
		required: false,
		default: 'white',
		validator: (value: string) => ['white', 'grey', 'light', 'gradient'].includes(value)
	})
	readonly color!: string;

	@Prop({
		type: String,
		required: false,
		default: 'both',
		validator: (value: string) =>
			[
				'none',
				'top',
				'top-small',
				'top-desktop',
				'bottom',
				'bottom-small',
				'both',
				'both-small',
				'both-large',
				'both-desktop'
			].includes(value)
	})
	readonly padding!: string;

	@Prop({
		type: String,
		required: false,
		default: 'normal',
		validator: (value: string) => ['normal', 'wide'].includes(value)
	})
	readonly width!: string;

	get backgroundColor(): string {
		switch (this.color) {
			case 'light':
				return 'bg-color-main-light';
			case 'grey':
				return 'bg-color-grey-lightest';
			case 'gradient':
				return 'custom-gradient';
			case 'white':
			default:
				return 'bg-color-white';
		}
	}

	get sectionPadding(): string {
		switch (this.padding) {
			case 'none':
				return '';
			case 'top-desktop':
				return 'sm:pt-16';
			case 'top':
				return 'pt-12 sm:pt-16';
			case 'top-small':
				return 'pt-8';
			case 'bottom':
				return 'pb-12 sm:pb-16';
			case 'bottom-small':
				return 'pb-8';
			case 'both-desktop':
				return 'sm:py-16';
			case 'both-small':
				return 'py-8';
			case 'both-large':
				return 'py-20 sm:py-24';
			case 'both':
			default:
				return 'py-12 sm:py-16';
		}
	}

	get sectionWidth(): string {
		switch (this.width) {
			case 'wide':
				return 'max-w-6xl';
			case 'normal':
			default:
				return 'max-w-5xl';
		}
	}
}
